import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

// Animation presets
export const fadeInUp = {
  initial: { opacity: 0, y: 60 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] },
};

export const fadeInLeft = {
  initial: { opacity: 0, x: -60 },
  animate: { opacity: 1, x: 0 },
  transition: { duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] },
};

export const fadeInRight = {
  initial: { opacity: 0, x: 60 },
  animate: { opacity: 1, x: 0 },
  transition: { duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] },
};

export const scaleIn = {
  initial: { opacity: 0, scale: 0.8 },
  animate: { opacity: 1, scale: 1 },
  transition: { duration: 0.6, ease: [0.25, 0.46, 0.45, 0.94] },
};

export const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2,
    },
  },
};

export const staggerItem = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.5, ease: [0.25, 0.46, 0.45, 0.94] },
};

// GSAP scroll animations
export const initScrollAnimations = () => {
  // Parallax backgrounds
  gsap.utils.toArray(".parallax-bg").forEach((bg) => {
    gsap.to(bg, {
      yPercent: -50,
      ease: "none",
      scrollTrigger: {
        trigger: bg,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
    });
  });

  // Skill bars animation
  gsap.utils.toArray(".skill-bar").forEach((bar) => {
    const width = bar.getAttribute("data-width");
    gsap.fromTo(
      bar,
      { width: "0%" },
      {
        width: width + "%",
        duration: 1.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: bar,
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
      }
    );
  });

  // Text reveal animations
  gsap.utils.toArray(".text-reveal").forEach((text) => {
    gsap.fromTo(
      text,
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power2.out",
        scrollTrigger: {
          trigger: text,
          start: "top 85%",
          toggleActions: "play none none reverse",
        },
      }
    );
  });

  // Card hover animations
  gsap.utils.toArray(".hover-card").forEach((card) => {
    const tl = gsap.timeline({ paused: true });

    tl.to(card, {
      y: -10,
      scale: 1.02,
      duration: 0.3,
      ease: "power2.out",
    });

    card.addEventListener("mouseenter", () => tl.play());
    card.addEventListener("mouseleave", () => tl.reverse());
  });
};

// Magnetic button effect
export const magneticEffect = (element) => {
  const magnetic = element;
  const magneticText = magnetic.querySelector(".magnetic-text");

  const activateMagnetic = (event) => {
    const boundBox = magnetic.getBoundingClientRect();
    const magneticStrength = 40;
    const magneticTextStrength = 80;

    const newX = (event.clientX - boundBox.left) / magnetic.offsetWidth - 0.5;
    const newY = (event.clientY - boundBox.top) / magnetic.offsetHeight - 0.5;

    gsap.to(magnetic, {
      duration: 1,
      x: newX * magneticStrength,
      y: newY * magneticStrength,
      ease: "power4.out",
    });

    if (magneticText) {
      gsap.to(magneticText, {
        duration: 1,
        x: newX * magneticTextStrength,
        y: newY * magneticTextStrength,
        ease: "power4.out",
      });
    }
  };

  const resetMagnetic = () => {
    gsap.to(magnetic, {
      duration: 1,
      x: 0,
      y: 0,
      ease: "elastic.out",
    });

    if (magneticText) {
      gsap.to(magneticText, {
        duration: 1,
        x: 0,
        y: 0,
        ease: "elastic.out",
      });
    }
  };

  magnetic.addEventListener("mousemove", activateMagnetic);
  magnetic.addEventListener("mouseleave", resetMagnetic);
};

// Page transition
export const pageTransition = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.5, ease: [0.25, 0.46, 0.45, 0.94] },
};
